/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.9.0 (NJsonSchema v10.6.8.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
// @ts-nocheck

import * as moment from 'moment';

export class ActivityLogClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param customer_id (optional) 
     * @param filter_producer_code (optional) 
     * @param portfolio (optional) 
     * @param onlyGateway (optional) 
     * @param perPage (optional) 
     * @param page (optional) 
     * @return Success
     */
    list(customer_id?: number | undefined, filter_producer_code?: string | undefined, portfolio?: string | undefined, onlyGateway?: number | undefined, perPage?: number | undefined, page?: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/activities/log/list?";
        if (customer_id === null)
            throw new Error("The parameter 'customer_id' cannot be null.");
        else if (customer_id !== undefined)
            url_ += "customer_id=" + encodeURIComponent("" + customer_id) + "&";
        if (filter_producer_code === null)
            throw new Error("The parameter 'filter_producer_code' cannot be null.");
        else if (filter_producer_code !== undefined)
            url_ += "filter_producer_code=" + encodeURIComponent("" + filter_producer_code) + "&";
        if (portfolio === null)
            throw new Error("The parameter 'portfolio' cannot be null.");
        else if (portfolio !== undefined)
            url_ += "portfolio=" + encodeURIComponent("" + portfolio) + "&";
        if (onlyGateway === null)
            throw new Error("The parameter 'onlyGateway' cannot be null.");
        else if (onlyGateway !== undefined)
            url_ += "onlyGateway=" + encodeURIComponent("" + onlyGateway) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    detail(customer_document_log_id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/activities/log/detail/{customer_document_log_id}";
        if (customer_document_log_id === undefined || customer_document_log_id === null)
            throw new Error("The parameter 'customer_document_log_id' must be defined.");
        url_ = url_.replace("{customer_document_log_id}", encodeURIComponent("" + customer_document_log_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDetail(_response);
        });
    }

    protected processDetail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    attachment(customer_document_log_id: number, name?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/activities/log/attachment/{customer_document_log_id}?";
        if (customer_document_log_id === undefined || customer_document_log_id === null)
            throw new Error("The parameter 'customer_document_log_id' must be defined.");
        url_ = url_.replace("{customer_document_log_id}", encodeURIComponent("" + customer_document_log_id));
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAttachment(_response);
        });
    }

    protected processAttachment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AdminClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    info(): Promise<void> {
        let url_ = this.baseUrl + "/api/admin/info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInfo(_response);
        });
    }

    protected processInfo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ConfrontoDatiAnimaClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getOugs(): Promise<EntitySelectItem[]> {
        let url_ = this.baseUrl + "/api/confrontodatianima/confronto-dati-anima/ougs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOugs(_response);
        });
    }

    protected processGetOugs(response: Response): Promise<EntitySelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntitySelectItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntitySelectItem[]>(null as any);
    }

    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param idUnitaOrganizzativa (optional) 
     * @param email (optional) 
     * @return Success
     */
    getComparedFile(dateFrom?: moment.Moment | undefined, dateTo?: moment.Moment | undefined, idUnitaOrganizzativa?: number | undefined, email?: string | undefined): Promise<ResponseCompareDatiAnima> {
        let url_ = this.baseUrl + "/api/confrontodatianima/confronto-dati-anima/getcomparedfile?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        if (idUnitaOrganizzativa === null)
            throw new Error("The parameter 'idUnitaOrganizzativa' cannot be null.");
        else if (idUnitaOrganizzativa !== undefined)
            url_ += "idUnitaOrganizzativa=" + encodeURIComponent("" + idUnitaOrganizzativa) + "&";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetComparedFile(_response);
        });
    }

    protected processGetComparedFile(response: Response): Promise<ResponseCompareDatiAnima> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponseCompareDatiAnima;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseCompareDatiAnima>(null as any);
    }
}

export class ConsentsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    dailyCustomerConsentAggregates(body?: DailyCustomerConsentAggregateQuery | undefined): Promise<DailyCustomerConsentAggregatesQueryResult> {
        let url_ = this.baseUrl + "/api/consents/daily-customer-consent-aggregates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDailyCustomerConsentAggregates(_response);
        });
    }

    protected processDailyCustomerConsentAggregates(response: Response): Promise<DailyCustomerConsentAggregatesQueryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DailyCustomerConsentAggregatesQueryResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DailyCustomerConsentAggregatesQueryResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    dailyCustomerConsentAggregatesCount(body?: DailyCustomerConsentAggregateQuery | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/consents/daily-customer-consent-aggregates/count";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDailyCustomerConsentAggregatesCount(_response);
        });
    }

    protected processDailyCustomerConsentAggregatesCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param ougId (optional) 
     * @return Success
     */
    customerDocumentConsentDefinitionGroups(ougId?: number | undefined): Promise<EntityConsentsGroup[]> {
        let url_ = this.baseUrl + "/api/consents/daily-customer-consent-groups?";
        if (ougId === null)
            throw new Error("The parameter 'ougId' cannot be null.");
        else if (ougId !== undefined)
            url_ += "ougId=" + encodeURIComponent("" + ougId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerDocumentConsentDefinitionGroups(_response);
        });
    }

    protected processCustomerDocumentConsentDefinitionGroups(response: Response): Promise<EntityConsentsGroup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityConsentsGroup[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityConsentsGroup[]>(null as any);
    }
}

export class CustomerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCustomer(id: number): Promise<GetCustomerResponse> {
        let url_ = this.baseUrl + "/api/customer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomer(_response);
        });
    }

    protected processGetCustomer(response: Response): Promise<GetCustomerResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCustomerResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCustomerResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteCustomer(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteCustomer(_response);
        });
    }

    protected processDeleteCustomer(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getCustomerDetail(id: number): Promise<GetCustomerResponse> {
        let url_ = this.baseUrl + "/api/customer/{id}/detail";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerDetail(_response);
        });
    }

    protected processGetCustomerDetail(response: Response): Promise<GetCustomerResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCustomerResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCustomerResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCustomerFromForm(id: number, body?: Body | undefined): Promise<Customer> {
        let url_ = this.baseUrl + "/api/customer/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = Object.keys(body as any).map((key) => {
            return encodeURIComponent(key) + '=' + encodeURIComponent((body as any)[key]);
        }).join('&')

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCustomerFromForm(_response);
        });
    }

    protected processUpdateCustomerFromForm(response: Response): Promise<Customer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Customer;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Customer>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCustomererFromForm(body?: Body2 | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/new/customer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = Object.keys(body as any).map((key) => {
            return encodeURIComponent(key) + '=' + encodeURIComponent((body as any)[key]);
        }).join('&')

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateCustomererFromForm(_response);
        });
    }

    protected processCreateCustomererFromForm(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    enableReceiveEmail(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/{id}/action/enablereceiveemail";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEnableReceiveEmail(_response);
        });
    }

    protected processEnableReceiveEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    disableReceiveEmail(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/{id}/action/disablereceiveemail";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDisableReceiveEmail(_response);
        });
    }

    protected processDisableReceiveEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param model_slug (optional) 
     * @return Success
     */
    sendOTPToCustomerBySMS(id: number, model_slug?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/{id}/action/sendsms/otp";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (model_slug === null || model_slug === undefined)
            throw new Error("The parameter 'model_slug' cannot be null.");
        else
            content_.append("model_slug", model_slug.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendOTPToCustomerBySMS(_response);
        });
    }

    protected processSendOTPToCustomerBySMS(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param otp (optional) 
     * @return Success
     */
    acceptSMSOTP(id: number, otp?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/{id}/action/smsaccept/otp";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (otp === null || otp === undefined)
            throw new Error("The parameter 'otp' cannot be null.");
        else
            content_.append("otp", otp.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAcceptSMSOTP(_response);
        });
    }

    protected processAcceptSMSOTP(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param contentType (optional) 
     * @param contentDisposition (optional) 
     * @param headers (optional) 
     * @param length (optional) 
     * @param name (optional) 
     * @param fileName (optional) 
     * @return Success
     */
    uploadSignedDocument(id: number, model_slug: string, contentType?: string | undefined, contentDisposition?: string | undefined, headers?: { [key: string]: string[]; } | undefined, length?: number | undefined, name?: string | undefined, fileName?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/{id}/action/upload/signeddocument/{model_slug}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (model_slug === undefined || model_slug === null)
            throw new Error("The parameter 'model_slug' must be defined.");
        url_ = url_.replace("{model_slug}", encodeURIComponent("" + model_slug));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType === null || contentType === undefined)
            throw new Error("The parameter 'contentType' cannot be null.");
        else
            content_.append("contentType", contentType.toString());
        if (contentDisposition === null || contentDisposition === undefined)
            throw new Error("The parameter 'contentDisposition' cannot be null.");
        else
            content_.append("contentDisposition", contentDisposition.toString());
        if (headers === null || headers === undefined)
            throw new Error("The parameter 'headers' cannot be null.");
        else
            content_.append("headers", JSON.stringify(headers));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("length", length.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("name", name.toString());
        if (fileName === null || fileName === undefined)
            throw new Error("The parameter 'fileName' cannot be null.");
        else
            content_.append("fileName", fileName.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadSignedDocument(_response);
        });
    }

    protected processUploadSignedDocument(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param model_slugs (optional) 
     * @return Success
     */
    sendDocumentsToCustomerByEmail(id: number, model_slugs?: string[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/{id}/action/sendemail/documents";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (model_slugs === null || model_slugs === undefined)
            throw new Error("The parameter 'model_slugs' cannot be null.");
        else
            model_slugs.forEach(item_ => content_.append("model_slugs", item_.toString()));

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendDocumentsToCustomerByEmail(_response);
        });
    }

    protected processSendDocumentsToCustomerByEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    sendMissingDocumentsByEmail(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/{id}/action/sendemail/missing/documents";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendMissingDocumentsByEmail(_response);
        });
    }

    protected processSendMissingDocumentsByEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param model_slugs (optional) 
     * @param reset_all (optional) 
     * @return Success
     */
    resetCustomerDocuments(id: number, model_slugs?: string[] | undefined, reset_all?: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/{id}/action/reset/customerdocuments";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (model_slugs === null || model_slugs === undefined)
            throw new Error("The parameter 'model_slugs' cannot be null.");
        else
            model_slugs.forEach(item_ => content_.append("model_slugs", item_.toString()));
        if (reset_all === null || reset_all === undefined)
            throw new Error("The parameter 'reset_all' cannot be null.");
        else
            content_.append("reset_all", reset_all.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResetCustomerDocuments(_response);
        });
    }

    protected processResetCustomerDocuments(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    confirmOTP(id: number, body?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/{id}/action/consents/confirm/otp";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConfirmOTP(_response);
        });
    }

    protected processConfirmOTP(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param document_consent_definition_id (optional) 
     * @param document_consent_respose_definition_id (optional) 
     * @param document_consent_response_definition_id (optional) 
     * @return Success
     */
    updateCustomerResponseFromForm(id: number, document_consent_definition_id?: number | undefined, document_consent_respose_definition_id?: string | undefined, document_consent_response_definition_id?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/{id}/action/consents/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (document_consent_definition_id === null || document_consent_definition_id === undefined)
            throw new Error("The parameter 'document_consent_definition_id' cannot be null.");
        else
            content_.append("document_consent_definition_id", document_consent_definition_id.toString());
        if (document_consent_respose_definition_id === null || document_consent_respose_definition_id === undefined)
            throw new Error("The parameter 'document_consent_respose_definition_id' cannot be null.");
        else
            content_.append("document_consent_respose_definition_id", document_consent_respose_definition_id.toString());
        if (document_consent_response_definition_id === null || document_consent_response_definition_id === undefined)
            throw new Error("The parameter 'document_consent_response_definition_id' cannot be null.");
        else
            content_.append("document_consent_response_definition_id", document_consent_response_definition_id.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCustomerResponseFromForm(_response);
        });
    }

    protected processUpdateCustomerResponseFromForm(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param otp (optional) 
     * @param document_consent_definition_group_id (optional) 
     * @return Success
     */
    confirmGroupOTP(id: number, otp?: string | undefined, document_consent_definition_group_id?: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/{id}/action/consent/groups/confirm/otp";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (otp === null || otp === undefined)
            throw new Error("The parameter 'otp' cannot be null.");
        else
            content_.append("otp", otp.toString());
        if (document_consent_definition_group_id === null || document_consent_definition_group_id === undefined)
            throw new Error("The parameter 'document_consent_definition_group_id' cannot be null.");
        else
            content_.append("document_consent_definition_group_id", document_consent_definition_group_id.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConfirmGroupOTP(_response);
        });
    }

    protected processConfirmGroupOTP(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param document_consent_definition_group_id (optional) 
     * @return Success
     */
    updateGroupResponsesFromForm(id: number, document_consent_definition_group_id?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/{id}/action/consent/groups/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (document_consent_definition_group_id === null || document_consent_definition_group_id === undefined)
            throw new Error("The parameter 'document_consent_definition_group_id' cannot be null.");
        else
            content_.append("document_consent_definition_group_id", document_consent_definition_group_id.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateGroupResponsesFromForm(_response);
        });
    }

    protected processUpdateGroupResponsesFromForm(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateGroupResponsesFromJsonData(id: number, body?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/{id}/action/json/consent/groups/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateGroupResponsesFromJsonData(_response);
        });
    }

    protected processUpdateGroupResponsesFromJsonData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param perPage (optional) 
     * @param page (optional) 
     * @return Success
     */
    logs(id: number, perPage?: number | undefined, page?: number | undefined): Promise<LogResponse> {
        let url_ = this.baseUrl + "/api/customer/{id}/logs?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogs(_response);
        });
    }

    protected processLogs(response: Response): Promise<LogResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LogResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LogResponse>(null as any);
    }

    /**
     * @return Success
     */
    documents(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/{id}/documents";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDocuments(_response);
        });
    }

    protected processDocuments(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param as_producer_code (optional) 
     * @param email (optional) 
     * @return Success
     */
    checkCustomerEmail(as_producer_code?: string | undefined, email?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/check/customers/email?";
        if (as_producer_code === null)
            throw new Error("The parameter 'as_producer_code' cannot be null.");
        else if (as_producer_code !== undefined)
            url_ += "as_producer_code=" + encodeURIComponent("" + as_producer_code) + "&";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckCustomerEmail(_response);
        });
    }

    protected processCheckCustomerEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    polizze(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/{id}/polizze";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPolizze(_response);
        });
    }

    protected processPolizze(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param picture (optional) 
     * @return Success
     */
    uploadPicture(id: number, picture?: FileParameter | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/{id}/upload/picture";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (picture === null || picture === undefined)
            throw new Error("The parameter 'picture' cannot be null.");
        else
            content_.append("picture", picture.data, picture.fileName ? picture.fileName : "picture");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadPicture(_response);
        });
    }

    protected processUploadPicture(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DocumentCompileAndDownloadClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    downloadSignedDocument(customer_document_id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/download/signeddocument/{customer_document_id}";
        if (customer_document_id === undefined || customer_document_id === null)
            throw new Error("The parameter 'customer_document_id' must be defined.");
        url_ = url_.replace("{customer_document_id}", encodeURIComponent("" + customer_document_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadSignedDocument(_response);
        });
    }

    protected processDownloadSignedDocument(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param producer_code (optional) 
     * @return Success
     */
    downloadCompiledDocumentByCustomerIdAndSlug(customer_id: number, document_slug: string, producer_code?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/{customer_id}/download/compileddocument/{document_slug}?";
        if (customer_id === undefined || customer_id === null)
            throw new Error("The parameter 'customer_id' must be defined.");
        url_ = url_.replace("{customer_id}", encodeURIComponent("" + customer_id));
        if (document_slug === undefined || document_slug === null)
            throw new Error("The parameter 'document_slug' must be defined.");
        url_ = url_.replace("{document_slug}", encodeURIComponent("" + document_slug));
        if (producer_code === null)
            throw new Error("The parameter 'producer_code' cannot be null.");
        else if (producer_code !== undefined)
            url_ += "producer_code=" + encodeURIComponent("" + producer_code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadCompiledDocumentByCustomerIdAndSlug(_response);
        });
    }

    protected processDownloadCompiledDocumentByCustomerIdAndSlug(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    downloadCustomerPicture(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/{id}/picture";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadCustomerPicture(_response);
        });
    }

    protected processDownloadCustomerPicture(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    downloadProducerLogo(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/{id}/logo";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadProducerLogo(_response);
        });
    }

    protected processDownloadProducerLogo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param producer_code (optional) 
     * @return Success
     */
    downloadProducerByCodeLogo(id: string, producer_code?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/{id}/bycode/logo?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (producer_code === null)
            throw new Error("The parameter 'producer_code' cannot be null.");
        else if (producer_code !== undefined)
            url_ += "producer_code=" + encodeURIComponent("" + producer_code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadProducerByCodeLogo(_response);
        });
    }

    protected processDownloadProducerByCodeLogo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MeClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMe(id?: number | undefined): Promise<GetCustomerResponse> {
        let url_ = this.baseUrl + "/api/me?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMe(_response);
        });
    }

    protected processGetMe(response: Response): Promise<GetCustomerResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCustomerResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCustomerResponse>(null as any);
    }

    /**
     * @param filter_name (optional) 
     * @param filter_producer_code (optional) 
     * @param page (optional) 
     * @param perPage (optional) 
     * @param portfolio (optional) 
     * @param include_sub_producers (optional) 
     * @param show_compliance_customers (optional) 
     * @param show_no_compliance_customers (optional) 
     * @param show_incomplete_customers (optional) 
     * @param upload_date_from (optional) 
     * @param upload_date_to (optional) 
     * @param compliant_date_from (optional) 
     * @param compliant_date_to (optional) 
     * @param auto_approvato (optional) 
     * @param user_id (optional) 
     * @return Success
     */
    getMeCustomers(filter_name?: string | undefined, filter_producer_code?: string | undefined, page?: number | undefined, perPage?: number | undefined, portfolio?: string | undefined, include_sub_producers?: boolean | undefined, show_compliance_customers?: boolean | undefined, show_no_compliance_customers?: boolean | undefined, show_incomplete_customers?: boolean | undefined, upload_date_from?: moment.Moment | undefined, upload_date_to?: moment.Moment | undefined, compliant_date_from?: moment.Moment | undefined, compliant_date_to?: moment.Moment | undefined, auto_approvato?: boolean | undefined, user_id?: number | undefined): Promise<GetCustomerResponse> {
        let url_ = this.baseUrl + "/api/me/customers?";
        if (filter_name === null)
            throw new Error("The parameter 'filter_name' cannot be null.");
        else if (filter_name !== undefined)
            url_ += "filter_name=" + encodeURIComponent("" + filter_name) + "&";
        if (filter_producer_code === null)
            throw new Error("The parameter 'filter_producer_code' cannot be null.");
        else if (filter_producer_code !== undefined)
            url_ += "filter_producer_code=" + encodeURIComponent("" + filter_producer_code) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (portfolio === null)
            throw new Error("The parameter 'portfolio' cannot be null.");
        else if (portfolio !== undefined)
            url_ += "portfolio=" + encodeURIComponent("" + portfolio) + "&";
        if (include_sub_producers === null)
            throw new Error("The parameter 'include_sub_producers' cannot be null.");
        else if (include_sub_producers !== undefined)
            url_ += "include_sub_producers=" + encodeURIComponent("" + include_sub_producers) + "&";
        if (show_compliance_customers === null)
            throw new Error("The parameter 'show_compliance_customers' cannot be null.");
        else if (show_compliance_customers !== undefined)
            url_ += "show_compliance_customers=" + encodeURIComponent("" + show_compliance_customers) + "&";
        if (show_no_compliance_customers === null)
            throw new Error("The parameter 'show_no_compliance_customers' cannot be null.");
        else if (show_no_compliance_customers !== undefined)
            url_ += "show_no_compliance_customers=" + encodeURIComponent("" + show_no_compliance_customers) + "&";
        if (show_incomplete_customers === null)
            throw new Error("The parameter 'show_incomplete_customers' cannot be null.");
        else if (show_incomplete_customers !== undefined)
            url_ += "show_incomplete_customers=" + encodeURIComponent("" + show_incomplete_customers) + "&";
        if (upload_date_from === null)
            throw new Error("The parameter 'upload_date_from' cannot be null.");
        else if (upload_date_from !== undefined)
            url_ += "upload_date_from=" + encodeURIComponent(upload_date_from ? "" + upload_date_from.toJSON() : "") + "&";
        if (upload_date_to === null)
            throw new Error("The parameter 'upload_date_to' cannot be null.");
        else if (upload_date_to !== undefined)
            url_ += "upload_date_to=" + encodeURIComponent(upload_date_to ? "" + upload_date_to.toJSON() : "") + "&";
        if (compliant_date_from === null)
            throw new Error("The parameter 'compliant_date_from' cannot be null.");
        else if (compliant_date_from !== undefined)
            url_ += "compliant_date_from=" + encodeURIComponent(compliant_date_from ? "" + compliant_date_from.toJSON() : "") + "&";
        if (compliant_date_to === null)
            throw new Error("The parameter 'compliant_date_to' cannot be null.");
        else if (compliant_date_to !== undefined)
            url_ += "compliant_date_to=" + encodeURIComponent(compliant_date_to ? "" + compliant_date_to.toJSON() : "") + "&";
        if (auto_approvato === null)
            throw new Error("The parameter 'auto_approvato' cannot be null.");
        else if (auto_approvato !== undefined)
            url_ += "auto_approvato=" + encodeURIComponent("" + auto_approvato) + "&";
        if (user_id === null)
            throw new Error("The parameter 'user_id' cannot be null.");
        else if (user_id !== undefined)
            url_ += "user_id=" + encodeURIComponent("" + user_id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMeCustomers(_response);
        });
    }

    protected processGetMeCustomers(response: Response): Promise<GetCustomerResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCustomerResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCustomerResponse>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMeDetail(id?: number | undefined): Promise<GetMeDetailResponse> {
        let url_ = this.baseUrl + "/api/me/detail?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMeDetail(_response);
        });
    }

    protected processGetMeDetail(response: Response): Promise<GetMeDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetMeDetailResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMeDetailResponse>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMeDocuments(id?: number | undefined): Promise<GetMeDetailResponse> {
        let url_ = this.baseUrl + "/api/me/documents?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMeDocuments(_response);
        });
    }

    protected processGetMeDocuments(response: Response): Promise<GetMeDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetMeDetailResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMeDetailResponse>(null as any);
    }

    /**
     * @param filter_producer_code (optional) 
     * @param perPage (optional) 
     * @param page (optional) 
     * @param portfolio (optional) 
     * @return Success
     */
    getMeLogs(filter_producer_code?: string | undefined, perPage?: number | undefined, page?: number | undefined, portfolio?: string | undefined): Promise<LogResponse> {
        let url_ = this.baseUrl + "/api/me/logs?";
        if (filter_producer_code === null)
            throw new Error("The parameter 'filter_producer_code' cannot be null.");
        else if (filter_producer_code !== undefined)
            url_ += "filter_producer_code=" + encodeURIComponent("" + filter_producer_code) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (portfolio === null)
            throw new Error("The parameter 'portfolio' cannot be null.");
        else if (portfolio !== undefined)
            url_ += "portfolio=" + encodeURIComponent("" + portfolio) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMeLogs(_response);
        });
    }

    protected processGetMeLogs(response: Response): Promise<LogResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LogResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LogResponse>(null as any);
    }

    /**
     * @return Success
     */
    getMeAllProducers(): Promise<void> {
        let url_ = this.baseUrl + "/api/me/producers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMeAllProducers(_response);
        });
    }

    protected processGetMeAllProducers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getMeAllUsers(): Promise<void> {
        let url_ = this.baseUrl + "/api/me/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMeAllUsers(_response);
        });
    }

    protected processGetMeAllUsers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getMeProducer(producer_id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/me/producer/{producer_id}";
        if (producer_id === undefined || producer_id === null)
            throw new Error("The parameter 'producer_id' must be defined.");
        url_ = url_.replace("{producer_id}", encodeURIComponent("" + producer_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMeProducer(_response);
        });
    }

    protected processGetMeProducer(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getMeSubProducers(): Promise<void> {
        let url_ = this.baseUrl + "/api/me/sub/producers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMeSubProducers(_response);
        });
    }

    protected processGetMeSubProducers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OAuthClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param grant_type (optional) 
     * @param client_id (optional) 
     * @param client_secret (optional) 
     * @param username (optional) 
     * @param password (optional) 
     * @param scope (optional) 
     * @return Success
     */
    token(grant_type?: string | undefined, client_id?: number | undefined, client_secret?: string | undefined, username?: string | undefined, password?: string | undefined, scope?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/oauth/token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (grant_type === null || grant_type === undefined)
            throw new Error("The parameter 'grant_type' cannot be null.");
        else
            content_.append("grant_type", grant_type.toString());
        if (client_id === null || client_id === undefined)
            throw new Error("The parameter 'client_id' cannot be null.");
        else
            content_.append("client_id", client_id.toString());
        if (client_secret === null || client_secret === undefined)
            throw new Error("The parameter 'client_secret' cannot be null.");
        else
            content_.append("client_secret", client_secret.toString());
        if (username === null || username === undefined)
            throw new Error("The parameter 'username' cannot be null.");
        else
            content_.append("username", username.toString());
        if (password === null || password === undefined)
            throw new Error("The parameter 'password' cannot be null.");
        else
            content_.append("password", password.toString());
        if (scope === null || scope === undefined)
            throw new Error("The parameter 'scope' cannot be null.");
        else
            content_.append("scope", scope.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processToken(_response);
        });
    }

    protected processToken(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PartialsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    postGET(): Promise<void> {
        let url_ = this.baseUrl + "/api/partials";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostGET(_response);
        });
    }

    protected processPostGET(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    postPOST(): Promise<void> {
        let url_ = this.baseUrl + "/api/partials";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPOST(_response);
        });
    }

    protected processPostPOST(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    postTest(): Promise<void> {
        let url_ = this.baseUrl + "/api/partials/posttest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostTest(_response);
        });
    }

    protected processPostTest(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ResetPasswordClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param email (optional) 
     * @return Success
     */
    placeToken(email?: string | undefined): Promise<ResetPasswordResponse> {
        let url_ = this.baseUrl + "/api/resetpassword?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPlaceToken(_response);
        });
    }

    protected processPlaceToken(response: Response): Promise<ResetPasswordResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResetPasswordResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResetPasswordResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    confirmReset(body?: ResetPasswordData | undefined): Promise<ResetPasswordResponse> {
        let url_ = this.baseUrl + "/reset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConfirmReset(_response);
        });
    }

    protected processConfirmReset(response: Response): Promise<ResetPasswordResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResetPasswordResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResetPasswordResponse>(null as any);
    }
}

export class StaticDataClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getProvinces(): Promise<void> {
        let url_ = this.baseUrl + "/api/provinces";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProvinces(_response);
        });
    }

    protected processGetProvinces(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getStatuses(): Promise<void> {
        let url_ = this.baseUrl + "/api/statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStatuses(_response);
        });
    }

    protected processGetStatuses(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getRoles(): Promise<void> {
        let url_ = this.baseUrl + "/api/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getToponyms(): Promise<void> {
        let url_ = this.baseUrl + "/api/toponyms";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetToponyms(_response);
        });
    }

    protected processGetToponyms(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getcatastoNationalCodes(): Promise<void> {
        let url_ = this.baseUrl + "/api/catastocodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetcatastoNationalCodes(_response);
        });
    }

    protected processGetcatastoNationalCodes(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class StatisticsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter_producer_code (optional) 
     * @param portfolio (optional) 
     * @return Success
     */
    complianceStatus(filter_producer_code?: string | undefined, portfolio?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/statistics/me/compliancestatus?";
        if (filter_producer_code === null)
            throw new Error("The parameter 'filter_producer_code' cannot be null.");
        else if (filter_producer_code !== undefined)
            url_ += "filter_producer_code=" + encodeURIComponent("" + filter_producer_code) + "&";
        if (portfolio === null)
            throw new Error("The parameter 'portfolio' cannot be null.");
        else if (portfolio !== undefined)
            url_ += "portfolio=" + encodeURIComponent("" + portfolio) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processComplianceStatus(_response);
        });
    }

    protected processComplianceStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param filter_producer_code (optional) 
     * @param portfolio (optional) 
     * @return Success
     */
    documentsStatus(filter_producer_code?: string | undefined, portfolio?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/statistics/me/documentsstatus?";
        if (filter_producer_code === null)
            throw new Error("The parameter 'filter_producer_code' cannot be null.");
        else if (filter_producer_code !== undefined)
            url_ += "filter_producer_code=" + encodeURIComponent("" + filter_producer_code) + "&";
        if (portfolio === null)
            throw new Error("The parameter 'portfolio' cannot be null.");
        else if (portfolio !== undefined)
            url_ += "portfolio=" + encodeURIComponent("" + portfolio) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDocumentsStatus(_response);
        });
    }

    protected processDocumentsStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UploadFileClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param contentType (optional) 
     * @param contentDisposition (optional) 
     * @param headers (optional) 
     * @param length (optional) 
     * @param name (optional) 
     * @param fileName (optional) 
     * @param order_number (optional) 
     * @param bulk_id (optional) 
     * @param redirect (optional) 
     * @return Success
     */
    upload(bulkid: string, contentType?: string | undefined, contentDisposition?: string | undefined, headers?: { [key: string]: string[]; } | undefined, length?: number | undefined, name?: string | undefined, fileName?: string | undefined, order_number?: number | undefined, bulk_id?: string | undefined, redirect?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/upload/file/{bulkid}";
        if (bulkid === undefined || bulkid === null)
            throw new Error("The parameter 'bulkid' must be defined.");
        url_ = url_.replace("{bulkid}", encodeURIComponent("" + bulkid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType === null || contentType === undefined)
            throw new Error("The parameter 'contentType' cannot be null.");
        else
            content_.append("contentType", contentType.toString());
        if (contentDisposition === null || contentDisposition === undefined)
            throw new Error("The parameter 'contentDisposition' cannot be null.");
        else
            content_.append("contentDisposition", contentDisposition.toString());
        if (headers === null || headers === undefined)
            throw new Error("The parameter 'headers' cannot be null.");
        else
            content_.append("headers", JSON.stringify(headers));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("length", length.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("name", name.toString());
        if (fileName === null || fileName === undefined)
            throw new Error("The parameter 'fileName' cannot be null.");
        else
            content_.append("fileName", fileName.toString());
        if (order_number === null || order_number === undefined)
            throw new Error("The parameter 'order_number' cannot be null.");
        else
            content_.append("order_number", order_number.toString());
        if (bulk_id === null || bulk_id === undefined)
            throw new Error("The parameter 'bulk_id' cannot be null.");
        else
            content_.append("bulk_id", bulk_id.toString());
        if (redirect === null || redirect === undefined)
            throw new Error("The parameter 'redirect' cannot be null.");
        else
            content_.append("redirect", redirect.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UserClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isInRoles(body?: IsInRolesRequest | undefined): Promise<IsInRolesResponseApiResponse> {
        let url_ = this.baseUrl + "/api/user/isinroles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsInRoles(_response);
        });
    }

    protected processIsInRoles(response: Response): Promise<IsInRolesResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IsInRolesResponseApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IsInRolesResponseApiResponse>(null as any);
    }
}

export interface CatastoNationalCode {
    id: number;
    code: string;
    description: string;
    nativeCustomers: Customer[] | null;
}

export interface Company {
    id: number;
    createdAt: moment.Moment | null;
    updatedAt: moment.Moment | null;
    description: string | null;
    companyCode: string | null;
    proceduraReclami: string | null;
    address: string | null;
    email: string | null;
    emailReclami: string | null;
    fax: string | null;
    faxReclami: string | null;
    provvigiones: Provvigione[] | null;
    producerMandates: ProducerMandate[] | null;
}

export interface Configuration {
    id: number;
    createdAt: moment.Moment | null;
    updatedAt: moment.Moment | null;
    organizationalUnitGroupCode: string | null;
    organizationalUnitGroup: OrganizationalUnitGroup;
}

export interface Consent {
    description: string | null;
    groupDescription: string | null;
    responseDescription: string | null;
    mandateCompanyDescription: string | null;
    statusCode: string | null;
    systemFieldType: string | null;
    updatedAt: moment.Moment;
    codiceCompagnia: string | null;
}

export interface ConsentsFilter {
    consentDefinitionId: number;
    response: ResponseType;
}

export interface Customer {
    id: number;
    createdAt: moment.Moment | null;
    updatedAt: moment.Moment | null;
    producerCode: string | null;
    type: string;
    firstName: string | null;
    lastName: string | null;
    description: string | null;
    pIva: string | null;
    fiscalCode: string;
    birthday: moment.Moment | null;
    birthplaceCode: string | null;
    toponym: string | null;
    civicNumber: string | null;
    address: string | null;
    cap: string | null;
    comune: string | null;
    locality: string | null;
    province: string | null;
    email: string | null;
    mobilePhone: string | null;
    fixedPhone: string | null;
    note: string | null;
    nation: string | null;
    referentFirstName: string | null;
    referentLastName: string | null;
    referentFiscalCode: string | null;
    allowReceiveEmail: boolean;
    pictureUrl: string | null;
    producer: Producer;
    customerComplianceStatus: CustomerComplianceStatus;
    birthplace: CatastoNationalCode;
    ownerProvince: Province;
    customerDocuments: CustomerDocument[] | null;
    customerDocumentConsents: CustomerDocumentConsent[] | null;
    savedDocumentGroup: DocumentGroup;
    activeListSlugs: string[] | null;
    complianceDate: moment.Moment | null;
}

export interface CustomerComplianceStatus {
    id: number;
    createdAt: moment.Moment | null;
    updatedAt: moment.Moment | null;
    sevenAStatusCode: string;
    sevenACustomerDocumentId: number | null;
    sevenADocumentId: number | null;
    sevenAStatusUpdatedAt: moment.Moment | null;
    sevenAStatus: Status;
    sevenADocument: Document;
    sevenACustomerDocument: CustomerDocument;
    sevenBStatusCode: string;
    sevenBCustomerDocumentId: number | null;
    sevenBDocumentId: number | null;
    sevenBStatusUpdatedAt: moment.Moment | null;
    sevenBStatus: Status;
    sevenBDocument: Document;
    sevenBCustomerDocument: CustomerDocument;
    privacyStatusCode: string;
    privacyCustomerDocumentId: number | null;
    privacyDocumentId: number | null;
    privacyStatusUpdatedAt: moment.Moment | null;
    privacyStatus: Status;
    privacyDocument: Document;
    privacyCustomerDocument: CustomerDocument;
    emailStatusCode: string;
    emailCustomerDocumentId: number | null;
    emailCustomerDocument: CustomerDocument;
    emailDocumentId: number | null;
    emailDocument: Document;
    emailStatusUpdatedAt: moment.Moment | null;
    emailStatus: Status;
    doc1StatusCode: string;
    doc1CustomerDocumentId: number | null;
    doc1DocumentId: number | null;
    doc1StatusUpdatedAt: moment.Moment | null;
    doc1Status: Status;
    doc1Document: Document;
    doc1CustomerDocument: CustomerDocument;
    doc2StatusCode: string;
    doc2CustomerDocumentId: number | null;
    doc2DocumentId: number | null;
    doc2StatusUpdatedAt: moment.Moment | null;
    doc2Status: Status;
    doc2Document: Document;
    doc2CustomerDocument: CustomerDocument;
    doc3StatusCode: string;
    doc3CustomerDocumentId: number | null;
    doc3DocumentId: number | null;
    doc3StatusUpdatedAt: moment.Moment | null;
    doc3Status: Status;
    doc3Document: Document;
    doc3CustomerDocument: CustomerDocument;
    doc4StatusCode: string;
    doc4CustomerDocumentId: number | null;
    doc4DocumentId: number | null;
    doc4StatusUpdatedAt: moment.Moment | null;
    doc4Status: Status;
    doc4Document: Document;
    doc4CustomerDocument: CustomerDocument;
    doc5StatusCode: string;
    doc5CustomerDocumentId: number | null;
    doc5DocumentId: number | null;
    doc5StatusUpdatedAt: moment.Moment | null;
    doc5Status: Status;
    doc5Document: Document;
    doc5CustomerDocument: CustomerDocument;
    doc6StatusCode: string;
    doc6CustomerDocumentId: number | null;
    doc6DocumentId: number | null;
    doc6StatusUpdatedAt: moment.Moment | null;
    doc6Status: Status;
    doc6Document: Document;
    doc6CustomerDocument: CustomerDocument;
    doc7StatusCode: string;
    doc7CustomerDocumentId: number | null;
    doc7DocumentId: number | null;
    doc7StatusUpdatedAt: moment.Moment | null;
    doc7Status: Status;
    doc7Document: Document;
    doc7CustomerDocument: CustomerDocument;
    doc8StatusCode: string;
    doc8CustomerDocumentId: number | null;
    doc8DocumentId: number | null;
    doc8StatusUpdatedAt: moment.Moment | null;
    doc8Status: Status;
    doc8Document: Document;
    doc8CustomerDocument: CustomerDocument;
    doc9StatusCode: string;
    doc9CustomerDocumentId: number | null;
    doc9DocumentId: number | null;
    doc9StatusUpdatedAt: moment.Moment | null;
    doc9Status: Status;
    doc9Document: Document;
    doc9CustomerDocument: CustomerDocument;
    doc10StatusCode: string;
    doc10CustomerDocumentId: number | null;
    doc10DocumentId: number | null;
    doc10StatusUpdatedAt: moment.Moment | null;
    doc10Status: Status;
    doc10Document: Document;
    doc10CustomerDocument: CustomerDocument;
    complianceDate: moment.Moment | null;
    complianceStatus: number;
    requestUpdateAt: moment.Moment | null;
    customerId: number | null;
    customer: Customer;
}

export interface CustomerDocument {
    id: number;
    createdAt: moment.Moment | null;
    updatedAt: moment.Moment | null;
    documentId: number;
    customerId: number;
    statusCode: string;
    urlSignedDocument: string | null;
    urlBiometricSign: string | null;
    result: string | null;
    authorizationUserId: number | null;
    producerCode: string | null;
    smsOtp: string | null;
    smsOtpRequestData: any | null;
    uploadUserId: number | null;
    customer: Customer;
    authorizer: User;
    uploader: User;
    logs: CustomerDocumentLog[] | null;
    producer: Producer;
    document: Document;
    status: Status;
}

export interface CustomerDocumentConsent {
    id: number;
    createdAt: moment.Moment | null;
    updatedAt: moment.Moment | null;
    statusCode: string | null;
    smsOtp: string | null;
    smsOtpRequestData: any | null;
    documentConsentResponseResult: string | null;
    documentSlug: string | null;
    customerId: number | null;
    documentConsentDefinitionId: number | null;
    documentConsentResponseDefinitionId: number | null;
    documentConsentResponseDescription: string | null;
    ownerCustomer: Customer;
    ownerDocumentConsentDefinition: DocumentConsentDefinition;
    ownerDocumentConsentResponseDefinition: DocumentConsentResponseDefinition;
    customerDocumentLogs: CustomerDocumentLog[] | null;
}

export interface CustomerDocumentLog {
    id: number;
    createdAt: moment.Moment | null;
    updatedAt: moment.Moment | null;
    customerDocumentId: number;
    dateTime: moment.Moment;
    userId: number;
    statusCode: string | null;
    result: string | null;
    message: string | null;
    extra: any | null;
    groupedLogs: CustomerDocumentLog[] | null;
    requestId: string | null;
    serverVersion: string | null;
    consentType: number | null;
    gatewayType: number | null;
    documentConsentResponseDescription: string | null;
    documentConsentResponseDefinitionId: number | null;
    documentConsentResponseDefinition: DocumentConsentResponseDefinition;
    user: User;
    customerDocument: CustomerDocument;
    customerConsentId: number | null;
    customerDocumentConsent: CustomerDocumentConsent;
    status: Status;
}

export interface DailyCustomerConsentAggregate {
    date: moment.Moment;
    customerId: number;
    customerDescription: string | null;
    customerAddress: string | null;
    customerTaxCode: string | null;
    producerCode: string | null;
    producerDescription: string | null;
    documentConsents: DocumentConsents[] | null;
}

export interface DailyCustomerConsentAggregateQuery {
    organizationalUnitGroupId: number | null;
    filter: string | null;
    pageNumber: number;
    pageSize: number;
    dateFrom: moment.Moment;
    dateTo: moment.Moment;
    consentsFilters: ConsentsFilter[] | null;
}

export interface DailyCustomerConsentAggregatesQueryResult {
    linkedOugs: EntitySelectItem[] | null;
    items: DailyCustomerConsentAggregate[] | null;
}

export interface Document {
    id: number;
    createdAt: moment.Moment | null;
    updatedAt: moment.Moment | null;
    url: string | null;
    description: string;
    expirationDate: moment.Moment | null;
    documentGroupId: number;
    producerType: string | null;
    type: string;
    slug: string;
    allowedActions: string | null;
    status: number;
    showInDashboard: boolean;
    documentGroup: DocumentGroup;
    documentConsentDefinition: DocumentConsentDefinition;
    customerDocuments: CustomerDocument[] | null;
    customerComplianceSevenAStatuses: CustomerComplianceStatus[] | null;
    customerComplianceSevenBStatuses: CustomerComplianceStatus[] | null;
    customerCompliancePrivacyStatuses: CustomerComplianceStatus[] | null;
    customerComplianceEmailStatuses: CustomerComplianceStatus[] | null;
    customerComplianceDoc1Statuses: CustomerComplianceStatus[] | null;
    customerComplianceDoc2Statuses: CustomerComplianceStatus[] | null;
    customerComplianceDoc3Statuses: CustomerComplianceStatus[] | null;
    customerComplianceDoc4Statuses: CustomerComplianceStatus[] | null;
    customerComplianceDoc5Statuses: CustomerComplianceStatus[] | null;
    customerComplianceDoc6Statuses: CustomerComplianceStatus[] | null;
    customerComplianceDoc7Statuses: CustomerComplianceStatus[] | null;
    customerComplianceDoc8Statuses: CustomerComplianceStatus[] | null;
    customerComplianceDoc9Statuses: CustomerComplianceStatus[] | null;
    customerComplianceDoc10Statuses: CustomerComplianceStatus[] | null;
}

export interface DocumentConsentDefinition {
    id: number;
    createdAt: moment.Moment | null;
    updatedAt: moment.Moment | null;
    name: string;
    description: string;
    documentGroupId: number | null;
    smsTemplateId: number | null;
    documentConsentDefinitionGroupId: number | null;
    fieldType: string | null;
    systemFieldType: string | null;
    jsonKey: string | null;
    autocompleteSource: string | null;
    required: number;
    order: number;
    defaultConsentResponseId: number | null;
    documentSlug: string | null;
    ownerDocumentGroup: DocumentGroup;
    ownerDocumentConsentDefinitionGroup: DocumentConsentDefinitionGroup;
    ownerSmsTemplate: SmsTemplate;
    defaultDocumentConsentResponseDefinition: DocumentConsentResponseDefinition;
    documentConsentResponseDefinitions: DocumentConsentResponseDefinition[] | null;
    documents: Document[] | null;
    customerDocumentConsents: CustomerDocumentConsent[] | null;
}

export interface DocumentConsentDefinitionGroup {
    id: number;
    createdAt: moment.Moment | null;
    updatedAt: moment.Moment | null;
    name: string;
    documentGroupId: number | null;
    smsTemplateId: number | null;
    ownerDocumentGroup: DocumentGroup;
    ownerSmsTemplate: SmsTemplate;
    documentConsentDefinitions: DocumentConsentDefinition[] | null;
}

export interface DocumentConsentResponseDefinition {
    id: number;
    createdAt: moment.Moment | null;
    updatedAt: moment.Moment | null;
    description: string;
    tag: string | null;
    type: string | null;
    iconUrl: string | null;
    result: string | null;
    order: number;
    label1: string | null;
    documentConsentDefinitionId: number;
    documentConsentDefinition: DocumentConsentDefinition;
    customerDocumentLogs: CustomerDocumentLog[] | null;
    documentConsentDefinitions: DocumentConsentDefinition[] | null;
    customerDocumentConsents: CustomerDocumentConsent[] | null;
}

export interface DocumentConsents {
    documentSlug: string | null;
    documentDescription: string | null;
    consents: Consent[] | null;
    readonly lastConsentUpdate: moment.Moment | null;
}

export interface DocumentGroup {
    id: number;
    createdAt: moment.Moment | null;
    updatedAt: moment.Moment | null;
    description: string;
    ownerProducerId: number | null;
    documentCompileVersion: number | null;
    activeSlugs: string | null;
    complianceSlugs: string | null;
    iconSet: string | null;
    documents: Document[] | null;
    documentConsentDefinitions: DocumentConsentDefinition[] | null;
    documentConsentDefinitionGroup: DocumentConsentDefinitionGroup;
    ownerProducer: Producer;
}

export interface EmailTemplate {
    id: number;
    createdAt: moment.Moment | null;
    updatedAt: moment.Moment | null;
    from: string;
    subject: string | null;
    body: string | null;
    bcc: string | null;
    cc: string | null;
    producers: Producer[] | null;
}

export interface EntityConsent {
    id: number;
    name: string | null;
    fieldType: string | null;
    autoCompleteSource: string | null;
    listaRisposte: EntityResponse[] | null;
}

export interface EntityConsentsGroup {
    id: number;
    name: string | null;
    entityConsentsList: EntityConsent[] | null;
}

export interface EntityResponse {
    id: number;
    description: string | null;
    tag: string | null;
    type: string | null;
}

export interface EntitySelectItem {
    id: number;
    description: string | null;
}

export interface GetCustomerResponse {
    id: number;
    createdAt: moment.Moment | null;
    updatedAt: moment.Moment | null;
    producerCode: string | null;
    type: string;
    firstName: string | null;
    lastName: string | null;
    description: string | null;
    pIva: string | null;
    fiscalCode: string;
    birthday: moment.Moment | null;
    birthplaceCode: string | null;
    toponym: string | null;
    civicNumber: string | null;
    address: string | null;
    cap: string | null;
    comune: string | null;
    locality: string | null;
    province: string | null;
    email: string | null;
    mobilePhone: string | null;
    fixedPhone: string | null;
    note: string | null;
    nation: string | null;
    referentFirstName: string | null;
    referentLastName: string | null;
    referentFiscalCode: string | null;
    allowReceiveEmail: boolean;
    pictureUrl: string | null;
    producer: Producer;
    customerComplianceStatus: CustomerComplianceStatus;
    birthplace: CatastoNationalCode;
    ownerProvince: Province;
    customerDocuments: CustomerDocument[] | null;
    customerDocumentConsents: CustomerDocumentConsent[] | null;
    savedDocumentGroup: DocumentGroup;
    activeListSlugs: string[] | null;
    complianceDate: moment.Moment | null;
    asProducerId: string | null;
    activeListSlugsResponse: string[] | null;
}

export interface GetMeDetailResponse {
    user: User;
    producer: Producer;
    organizationalUnitGroup: OrganizationalUnitGroup;
}

export interface IsInRolesRequest {
    roles: string[] | null;
    mustHaveAll: boolean;
}

export interface IsInRolesResponse {
    isInRoles: boolean;
}

export interface IsInRolesResponseApiResponse {
    success: boolean;
    error: number | null;
    message: string | null;
    result: IsInRolesResponse;
}

export interface LogResponse {
    count: number;
    perPage: number;
    currentPage: number;
    last: boolean;
    data: any | null;
}

export interface OAuthAccessToken {
    id: string;
    userId: number | null;
    clientId: number;
    name: string | null;
    scopes: string | null;
    revoked: boolean;
    createdAt: moment.Moment | null;
    updatedAt: moment.Moment | null;
    expiresAt: moment.Moment | null;
    user: User;
    client: OAuthClient;
}

export interface OAuthClient {
    id: number;
    createdAt: moment.Moment | null;
    updatedAt: moment.Moment | null;
    userId: number | null;
    name: string;
    secret: string;
    redirect: string;
    personalAccessClient: boolean;
    passwordClient: boolean;
    revoked: boolean;
    user: User;
    accessTokens: OAuthAccessToken[] | null;
}

export interface OrganizationalUnitGroup {
    id: number;
    createdAt: moment.Moment | null;
    updatedAt: moment.Moment | null;
    organizationalUnitGroupCode: string;
    producerId: number | null;
    description: string | null;
    email: string | null;
    urlAnima: string | null;
    type: string | null;
    animaWhitelistIP: string | null;
    smsServiceName: string | null;
    smsServiceApiKey: string | null;
    smsServiceApiSecret: string | null;
    defaultUsersAutomaticAuthorizeDocuments: boolean | null;
    defaultUsersCanViewCustomerPortfolio: number | null;
    defaultProducerCodeSuffix: string | null;
    codiceSoftwareDistribution: string | null;
    producerCodeTemplate: string | null;
    accessDisabled: boolean;
    linkedProducer: Producer;
    associatedProducers: Producer[] | null;
    associatedUsers: User[] | null;
    configurations: Configuration[] | null;
}

export interface Producer {
    id: number;
    createdAt: moment.Moment | null;
    updatedAt: moment.Moment | null;
    parentProducerId: number | null;
    parentProducerCode: string | null;
    producerCode: string;
    description: string | null;
    email: string | null;
    emailReclami: string | null;
    organizationalUnitGroupCode: string;
    ruiCode: string | null;
    ruiSectionCode: string | null;
    type: string | null;
    documentGroupId: number | null;
    emailTemplateId: number | null;
    smsTemplateId: number | null;
    subscriptionDate: moment.Moment | null;
    addressOperationalHeadquarters: string | null;
    phone: string | null;
    faxReclami: string | null;
    pIva: string | null;
    fiscalCode: string | null;
    siteAndEmail: string | null;
    webSite: string | null;
    pec: string | null;
    pecReclami: string | null;
    note: string | null;
    hasCompaniesObligations: boolean;
    companiesWithObligations: string | null;
    sevenBPartIIIPointA: boolean;
    logoUrl: string | null;
    documentsFooter: string | null;
    documentsHeader: string | null;
    commonDataAuthKey: string | null;
    commonDataAuthSecret: string | null;
    commonDataAuthPropagate: boolean;
    printIn7B: boolean;
    notesSectionIII: string | null;
    notesSectionIV: string | null;
    emailSendType: string | null;
    parentProducer: Producer;
    organizationalUnitGroup: OrganizationalUnitGroup;
    users: User[] | null;
    producerDocumentConsentDefaults: ProducerDocumentConsentDefault[] | null;
    customers: Customer[] | null;
    customerDocuments: CustomerDocument[] | null;
    ownedDocumentGroups: DocumentGroup[] | null;
    userProducers: UserProducer[] | null;
    producerMandates: ProducerMandate[] | null;
    producerCollaborationsFrom: ProducerCollaboration[] | null;
    producerCollaborationsTo: ProducerCollaboration[] | null;
    smsTemplate: SmsTemplate;
    emailTemplate: EmailTemplate;
}

export interface ProducerCollaboration {
    id: number;
    createdAt: moment.Moment | null;
    updatedAt: moment.Moment | null;
    producerIdFrom: number;
    producerIdTo: number;
    producerRuiCodeTo: string | null;
    typeOfCollaboration: string | null;
    ownerProducerFrom: Producer;
    ownerProducerTo: Producer;
}

export interface ProducerDocumentConsentDefault {
    id: number;
    createdAt: moment.Moment | null;
    updatedAt: moment.Moment | null;
    producerId: number;
    documentConsentDefinitionId: number;
    defaultValue: string | null;
}

export interface ProducerMandate {
    id: number;
    createdAt: moment.Moment | null;
    updatedAt: moment.Moment | null;
    producerId: number;
    producerCode: string | null;
    companyId: number | null;
    companyCode: string | null;
    whichProvvigione: string | null;
    ownerProducer: Producer;
    ownerCompany: Company;
    provvigiones: Provvigione[] | null;
}

export interface Province {
    id: number;
    code: string | null;
    description: string | null;
    customers: Customer[] | null;
}

export interface Provvigione {
    id: number;
    createdAt: moment.Moment | null;
    updatedAt: moment.Moment | null;
    expiration_date: moment.Moment | null;
    value1: string | null;
    value2: string | null;
    value3: string | null;
    value4: string | null;
    value5: string | null;
    value6: string | null;
    value1Note: string | null;
    value2Note: string | null;
    value3Note: string | null;
    value4Note: string | null;
    value5Note: string | null;
    value6Note: string | null;
    noteDescription: string | null;
    note1: string | null;
    note2: string | null;
    note3: string | null;
    note4: string | null;
    companyId: number | null;
    producerMandateId: number | null;
    company: Company;
    producerMandate: ProducerMandate;
    companyDescription: string | null;
    dataComputed: any | null;
}

export interface ResetPasswordData {
    email: string | null;
    token: string | null;
    newPassword: string | null;
}

export interface ResetPasswordResponse {
    token: string | null;
    error: string | null;
    success: boolean;
}

export interface ResponseCompareDatiAnima {
    message: string | null;
    error: string | null;
}

export interface ResponseType {
    responseDefinitionId: number;
    from: string | null;
    to: string | null;
    responseDescription: string | null;
}

export interface Role {
    id: number;
    name: string;
    slug: string;
    description: string | null;
    users: User[] | null;
}

export interface SmsTemplate {
    id: number;
    createdAt: moment.Moment | null;
    updatedAt: moment.Moment | null;
    from: string;
    text: string | null;
    documentConsentDefinitionGroups: DocumentConsentDefinitionGroup[] | null;
    documentConsentDefinitions: DocumentConsentDefinition[] | null;
    producers: Producer[] | null;
}

export interface Status {
    id: number;
    code: string;
    description: string;
    message: string | null;
    compliance: boolean;
    customerDocuments: CustomerDocument[] | null;
    customerDocumentLogs: CustomerDocumentLog[] | null;
}

export interface User {
    id: number;
    createdAt: moment.Moment | null;
    updatedAt: moment.Moment | null;
    username: string;
    displayName: string;
    email: string;
    password: string;
    roleId: number;
    producerCode: string | null;
    organizationalUnitGroupCode: string | null;
    emailTemplateId: number | null;
    smsTemplateId: number | null;
    canAuthorizeDocuments: boolean;
    automaticAuthorizeDocuments: boolean | null;
    rememberToken: string | null;
    commonDataAuthKey: string | null;
    commonDataAuthSecret: string | null;
    canViewCustomerPortfolio: boolean;
    accessDisabled: boolean;
    producer: Producer;
    organizationalUnitGroup: OrganizationalUnitGroup;
    role: Role;
    oAuthClients: OAuthClient[] | null;
    oAuthAccessTokens: OAuthAccessToken[] | null;
    customerDocumentLogs: CustomerDocumentLog[] | null;
    authorizedCustomerDocuments: CustomerDocument[] | null;
    uploadedCustomerDocuments: CustomerDocument[] | null;
    userProducers: UserProducer[] | null;
}

export interface UserProducer {
    id: number;
    createdAt: moment.Moment | null;
    updatedAt: moment.Moment | null;
    userId: number;
    producerId: number;
    user: User;
    producer: Producer;
}

export interface Body {
    producer_code: string;
    as_producer_id: string;
    type: string;
    firstname: string;
    lastname: string;
    description: string;
    piva: string;
    fiscal_code: string;
    birthday: moment.Moment;
    birthplace: string;
    toponym: string;
    civic_number: string;
    address: string;
    cAP: string;
    comune: string;
    province: string;
    email: string;
    mobile_phone: string;
    fixed_phone: string;
    note: string;
    nation: string;
    referent_firstname: string;
    referent_lastname: string;
    referent_fiscalcode: string;
}

export interface Body2 {
    producer_code: string;
    as_producer_id: string;
    type: string;
    firstname: string;
    lastname: string;
    description: string;
    piva: string;
    fiscal_code: string;
    birthday: moment.Moment;
    birthplace: string;
    toponym: string;
    civic_number: string;
    address: string;
    cAP: string;
    comune: string;
    province: string;
    email: string;
    mobile_phone: string;
    fixed_phone: string;
    note: string;
    nation: string;
    referent_firstname: string;
    referent_lastname: string;
    referent_fiscalcode: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}